<div class="message-list__wrap">
  <tui-scrollbar *ngIf="chat" waIntersectionRoot class="message-list__scrollbar" (scroll)="onScroll()">
    <tui-loader [inheritColor]="true" [showLoader]="loader"></tui-loader>

    <div class="message-list">
      <ng-container *ngIf="sponsoredMessageVisible">
        <app-message
          [message]="sponsoredMessage"
          (sponsoredButtonClicked)="sponsoredButtonClicked($event)"
          (clickUserId)="clickUserId($event)"
          (clickUsername)="clickUsername($event)"
        ></app-message>
      </ng-container>

      <div *ngFor="let messageGroup of chat.messages | messagesGrouping" class="message-date-group">
        <ng-container *ngFor="let message of messageGroup.messages">
          <app-message
            #intObserverReading="IntersectionObserver"
            waIntersectionObserver
            waIntersectionThreshold="1"
            (waIntersectionObservee)="onReadeMessage($event, message, intObserverReading)"
            #dropdown="tuiDropdown"
            tuiDropdownContext
            [tuiDropdown]="contextMenu"
            [message]="message"
            [lastReadOutboxMessageId]="chat.lastReadOutboxMessageId"
            (contextmenu)="getMessageViewers(message)"
            (botCommandClicked)="handleBotCommand($event)"
            (sendBotTextCommand)="sendBotTextCommand($event)"
            (gotoMessage)="scrollToMessage($event)"
            (clickUserId)="clickUserId($event)"
            (clickUsername)="clickUsername($event)"
          ></app-message>

          <ng-template #contextMenu>
            <tui-data-list tuiDataListDropdownManager class="context-menu" role="menu">
              <ng-container *ngFor="let item of contextMenuItems">
                <ng-container *ngIf="item.visible(message, item)">
                  <ng-container [ngSwitch]="item.name">
                    <ng-container *ngSwitchCase="'viewers'">
                      <div class="separator"></div>
                      <button
                        tuiOption
                        new
                        class="context-menu__item"
                        tuiDropdownAlign="right"
                        [tuiDropdownManual]="userListVisible"
                        [tuiDropdown]="userListTmp"
                        [tuiDropdownSided]="true"
                        (click)="item.action?.(message.id)"
                      >
                        <app-icon class="icon" [src]="item.iconName" [size]="'18px'"></app-icon>

                        {{
                          item.count!
                            | numeralPlurals
                              : [
                                  'components.messageList.labels.viewOne' | translate,
                                  'components.messageList.labels.viewFew' | translate,
                                  'components.messageList.labels.viewMany' | translate,
                                ]
                        }}
                      </button>
                    </ng-container>

                    <button
                      *ngSwitchDefault
                      tuiOption
                      new
                      class="context-menu__item"
                      (click)="item.action?.(message.id); dropdown.toggle(false)"
                    >
                      <app-icon class="icon" [src]="item.iconName" [size]="'18px'"></app-icon>

                      {{ item.title }}
                    </button>

                    <ng-template #userListTmp>
                      <tui-data-list tuiDataListDropdownManager class="context-menu">
                        <tui-scrollbar class="message-list__scrollbar">
                          <button
                            *ngFor="let user of userList"
                            tuiOption
                            new
                            class="context-menu__item"
                            (click)="user.id ? viewUserProfile(user.id) : ''"
                          >
                            <tui-avatar
                              [src]="user.photo ? (user.photo | safe: 'url') : (user.fullName | tuiInitials)"
                              [size]="'s'"
                              [round]="true"
                              [style.background]="
                                !user.photo && user.fullName ? (user.fullName | tuiAutoColor) : ('' | tuiAutoColor)
                              "
                            ></tui-avatar>

                            {{ user.fullName }}
                          </button>
                        </tui-scrollbar>
                      </tui-data-list>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tui-data-list>
          </ng-template>

          <ng-template #confirmDeleteDialogTemplate let-observer>
            <div class="tui-space_bottom-3">
              <label
                *ngIf="chat.type._ === 'chatTypePrivate' && message.canBeDeletedForAllUsers"
                [tuiBlock]="tuiElementMediumSize"
              >
                <input tuiCheckbox type="checkbox" [(ngModel)]="deleteMessagesForAll" />
                {{ 'components.messageList.labels.deleteChatTypePrivate' | translate }} {{ chat.title }}
              </label>

              <label
                *ngIf="chat.type._ === 'chatTypeBasicGroup' && message.canBeDeletedForAllUsers"
                [tuiBlock]="tuiElementMediumSize"
              >
                <input tuiCheckbox type="checkbox" [(ngModel)]="deleteMessagesForAll" />
                {{ 'components.messageList.labels.deleteChatTypeBasicGroupForAll' | translate }}
              </label>

              <p *ngIf="chat.type._ === 'chatTypeBasicGroup' && !message.canBeDeletedForAllUsers">
                {{ 'components.messageList.labels.deleteChatTypeBasicGroupForMe' | translate }}
              </p>

              <p *ngIf="chat.type._ === 'chatTypeSupergroup' || chat.type._ === 'chatTypeSecret'">
                {{ 'components.messageList.labels.deleteChatTypeSupergroup' | translate }}
              </p>
            </div>

            <button
              tuiButton
              type="button"
              class="tui-space_right-3"
              [size]="tuiElementMediumSize"
              (click)="applyDelete(observer, deleteMessagesForAll)"
            >
              {{ 'common.buttons.delete' | translate }}
            </button>

            <button
              tuiButton
              type="button"
              appearance="secondary"
              [size]="tuiElementMediumSize"
              (click)="observer.complete()"
            >
              {{ 'common.buttons.cancel' | translate }}
            </button>
          </ng-template>

          <ng-template #confirmPinDialogTemplate let-observer>
            <div class="tui-space_bottom-3">
              <label
                *ngIf="chat.type._ === 'chatTypePrivate' && chat.id !== (authUser$ | async)?.telegramId"
                [tuiBlock]="tuiElementMediumSize"
              >
                <input tuiCheckbox type="checkbox" [(ngModel)]="pinMessageForAll" />
                {{ 'components.messageList.labels.pinChatTypePrivate' | translate }} {{ chat.title }}
              </label>

              <label *ngIf="chat.type._ === 'chatTypeBasicGroup'" [tuiBlock]="tuiElementMediumSize">
                <input tuiCheckbox type="checkbox" [(ngModel)]="notifyPinnedMessageForAll" />
                {{ 'components.messageList.labels.pinChatTypeBasicGroup' | translate }}
              </label>

              <p *ngIf="chat.type._ === 'chatTypeSupergroup' || chat.type._ === 'chatTypeSecret'">
                {{ 'components.messageList.labels.pinChatTypeSupergroup' | translate }}
              </p>
            </div>

            <button
              tuiButton
              type="button"
              class="tui-space_right-3"
              [size]="tuiElementMediumSize"
              (click)="applyPin(observer, pinMessageForAll, notifyPinnedMessageForAll)"
            >
              {{ 'components.messageList.buttons.pin' | translate }}
            </button>

            <button
              tuiButton
              type="button"
              appearance="secondary"
              [size]="tuiElementMediumSize"
              (click)="observer.complete()"
            >
              {{ 'common.buttons.cancel' | translate }}
            </button>
          </ng-template>
        </ng-container>

        <app-message-custom>{{ messageGroup.date }}</app-message-custom>
      </div>
    </div>
  </tui-scrollbar>

  <div class="button-scroll-bottom__wrap" [class.visibled]="scrollToBottomButtonVisible">
    <button
      tuiIconButton
      class="button-scroll-bottom"
      type="button"
      [appearance]="'primary'"
      [iconStart]="'@tui.arrow-down'"
      [style.border-radius.%]="100"
      [size]="'m'"
      [tuiHint]="'components.messageList.buttons.scrollBottom' | translate"
      (click)="scrollToBottom()"
    ></button>
  </div>
</div>
